<template lang="pug">
.is-flex.is-flex-direction-row.signin-container(v-if="!user")
  section.p-6.is-flex-grow-1.is-flex.is-flex-direction-column(style="overflow: scroll")
    .pb-3
      a(:href="`https://www.emly.${rootDomain}`" target="_blank")  
        img(src="../../../assets/logo_black.svg", style="height:36px;")
    .is-flex-grow-1.is-flex.is-align-items-center
      .columns.is-centered.is-flex-grow-1
        .column.is-8-desktop.is-10-tablet.is-12-mobile
          div 
            
            h1.title.is-3(v-t="'signin.title'")
            p.subtitle.has-text-grey.is-6 {{ $t('signin.subtitle') }}
            div.notification.is-danger(v-show="signinFailed") {{$t('signin.validation.invalid_credentials')}}
            div.notification.is-danger(v-show="fbSigninFailed") {{$t('signin.validation.no_account')}}
            form(v-on:submit.prevent="submit")
              b-field(:label="$t('signin.email_label')" :type="errors.has('email') ? 'is-danger': ''" :message="errors.has('email') ? errors.first('email') : ''")
                b-input(type="email" ref="emailInput" v-validate="'required|email'" :placeholder="$t('signin.email_placeholder')" icon="email-outline" v-model="email" name="email" data-qa="signin-email" )
              b-field(:label="$t('signin.password_label')" :type="errors.has('password') ? 'is-danger': ''" :message="errors.has('password') ? errors.first('password') : ''")
                b-input(type="password" ref="passwordInput" v-validate="'required'" :placeholder="$t('signin.password_placeholder')" icon="lock" v-model="password" name="password" data-qa="signin-password" )
              button.is-hidden(type="submit") {{$t('signin.actions.signin')}}
              .mb-5
                a.has-text-black(@click="startPasswordRecovery") 
                  b {{$t('signin.forgot_link')}} 
              .buttons
                button.button.is-black.is-fullwidth.is-medium(type="submit" :class="loading ? 'is-loading': ''" @click="submit") {{$t('signin.actions.signin')}}
            hr-text.my-6 
              span.has-text-grey {{ $t('misc.or') }}
            p.subtitle.is-6.has-text-centered {{$t('signin.facebook_signin_title')}}
            .field
              .control
                FacebookSignin.is-fullwidth(@signedIn="fbSignedIn" :loading="fbLoading")
            
            p.has-text-centered
              span {{$t('signin.no_account')}} 
              router-link(to="/signup")
                b {{$t('signin.signup_link')}}
  section.p-6.signin-cover.is-flex-grow-1.is-hidden-touch.is-flex.is-flex-direction-row.is-align-items-end(:style="{'background-image': `url('${bgImage}')`}") 
    
    
    div
      .py-6
        p
          span.icon.has-text-white
            i.mdi.mdi-format-quote-open.mdi-48px
        h2.title.is-2.has-text-white(style="line-height: 1.25em") {{ quote.quote }}
        h3.title.is-4.has-text-white {{quote.author}}
        p.subtitle.has-text-white(v-if="quote.company") ({{ quote.company }})
    
      .pb-6
        h3.title.is-4.has-text-white(v-t="'signin.explore_more_title'")
        p 
          a.button.is-outlined.is-medium.is-white(:href="`https://www.emly.${rootDomain}`" target="_blank") 
            b(v-t="'actions.learn_more'")
            span.icon
              i.mdi.mdi-open-in-new
</template>

<script>
import ForgetPasswordForm from '../ForgetPasswordForm.vue'
import FacebookSignin from './FacebookSignin'
import {mapState} from 'vuex'
const images = [
  'https://images.pexels.com/photos/2104499/pexels-photo-2104499.jpeg?auto=compress&cs=tinysrgb&w=1600',
  'https://images.pexels.com/photos/6331049/pexels-photo-6331049.jpeg?auto=compress&cs=tinysrgb&w=1600',
  'https://images.pexels.com/photos/3293037/pexels-photo-3293037.jpeg?auto=compress&cs=tinysrgb&w=1600'
]

import QUOTES from '../../../../constants/salonQuotes'

export default {
  name: 'SigninForm',
  components: {
    FacebookSignin
  },

  data() {
    return {
      password: '',
      email: '',
      signinFailed: false,
      fbSigninFailed: false,
      loading: false,
      returnUrl: undefined,
      fbLoading: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    bgImage() {
      return images[Math.floor(Math.random() * images.length)]
    },
    quote() {
      let quotes = QUOTES[this.$i18n.locale] || QUOTES.en
      return quotes[Math.floor(Math.random() * quotes.length)]
    },
    rootDomain() {
      return window.location.hostname.split('.').pop()
    }
  },
  mounted() {
    if (this.user) {
      return
    }
    if (this.$route.query.email) {
      this.email = this.$route.query.email
      this.$refs.passwordInput.focus()
    } else {
      this.$refs.emailInput.focus()
    }

    this.returnUrl = this.$route.query.returnUrl
  },
  methods: {
    async fbSignedIn({userAccessToken}) {
      if (this.fbLoading) {
        return
      }
      this.fbLoading = true
      try {
        await this.$store.dispatch('auth/signinWithFacebook', userAccessToken)
        this.redirectOnSignin()
      } catch (err) {
        this.$handleAPIError(err)
        this.fbSigninFailed = true
      }
      this.fbLoading = false
    },
    async submit() {
      if (this.loading) {
        return
      }
      let valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      try {
        await this.$store.dispatch('auth/signin', {
          email: this.email,
          password: this.password
        })
        this.redirectOnSignin()
      } catch (err) {
        this.$handleAPIError(err)
        this.signinFailed = true
      }
      this.loading = false
    },
    redirectOnSignin() {
      if (this.returnUrl) {
        this.$router.push(this.returnUrl)
      } else {
        this.$router.push('/calendar')
      }
    },
    startPasswordRecovery() {
      this.$buefy.modal.open({
        parent: this.$parent,
        hasModalCard: true,
        component: ForgetPasswordForm,
        canCancel: ['escape']
      })
    }
  }
}
</script>
<style scoped>
.signin-container section {
  flex-basis: 0;
}

.signin-cover {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}
</style>
